import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
/*
  Generated class for the ServiceSidemenuProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ServiceSidemenuProvider {

  splitPaneState: boolean;

	constructor(public platform: Platform) {
		this.splitPaneState = true;
	}

	setSplitPane(state: boolean) {
		if (this.platform.width() > 900) {
			this.splitPaneState = state;
		} else {
			this.splitPaneState = false;
		}
	}

	getSplitPane() {
    //return this.splitPaneState
		if (this.platform.width() > 900) {
			return this.splitPaneState;
		} else {
			return false;
		}
	}

}



// WEBPACK FOOTER //
// ./src/providers/service-sidemenu/service-sidemenu.ts